import { PayloadAction } from '@reduxjs/toolkit';

import { MockupPreviewVariant, MockupState } from 'editor/src/store/mockup/types';

const setMockupPreviewReducer = (state: MockupState, action: PayloadAction<MockupPreviewVariant | undefined>) => {
  state.preview.appliedVariant = action.payload;
};

export default setMockupPreviewReducer;
